import { render, staticRenderFns } from "./LeftNav.vue?vue&type=template&id=86e24d96&scoped=true"
import script from "./LeftNav.vue?vue&type=script&lang=js"
export * from "./LeftNav.vue?vue&type=script&lang=js"
import style0 from "./LeftNav.vue?vue&type=style&index=0&id=86e24d96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86e24d96",
  null
  
)

export default component.exports